var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("b-loading", {
        attrs: { "is-full-page": false },
        model: {
          value: _vm.isLoading,
          callback: function ($$v) {
            _vm.isLoading = $$v
          },
          expression: "isLoading",
        },
      }),
      _vm.stockScan.length !== 0
        ? _c("h1", { staticClass: "title" }, [
            _vm._v(" " + _vm._s(_vm.stockScan[0].CUSTOMER_NAME) + " "),
          ])
        : _vm._e(),
      _vm.stockScan.length !== 0
        ? _c("h1", { staticClass: "subtitle" }, [
            _vm._v(" " + _vm._s(_vm.stockScan[0].CUSTOMER_COUNTRY) + " "),
            _c("img", {
              staticStyle: { "max-height": "15px" },
              attrs: {
                src: `https://flagcdn.com/w20/${_vm.stockScan[0].CUSTOMER_COUNTRY.toLowerCase()}.png`,
                alt: "english flag",
              },
            }),
            _vm._v(
              " " +
                _vm._s(_vm.stockScan[0].CUSTOMER_CITY) +
                " " +
                _vm._s(_vm.stockScan[0].CUSTOMER_ADDRESS) +
                " "
            ),
          ])
        : _vm._e(),
      _c(
        "b-table",
        {
          attrs: {
            data: _vm.stockScan,
            "per-page": 15,
            paginated: "",
            "default-sort": "BARCODE",
            "default-sort-direction": "asc",
          },
        },
        [
          _c("b-table-column", {
            attrs: {
              field: "BARCODE",
              label: _vm.$t("consignee.stock.details.barcodes"),
              searchable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(" " + _vm._s(props.row.BARCODE) + " ")]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: {
              field: "ON_SITE_ELAPSED_DAYS",
              sortable: "",
              label: _vm.$t("consignee.stock.details.storage_time"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._v(" " + _vm._s(props.row.ON_SITE_ELAPSED_DAYS) + " "),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: {
              field: "ON_SITE_TIMESTAMP",
              label: _vm.$t("consignee.stock.details.arrival_on_site"),
              searchable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._v(" " + _vm._s(props.row.ON_SITE_TIMESTAMP) + " "),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }